import { QESTextInput, QESTextArea, QESButton } from "@app/shared/qes-standards";
import { FlyoutFooter, FlyoutContext } from "@app/shared/Flyouts";
import { FC, useState, useContext, useRef, JSX } from "react";
import TutorialsService from "@app/tutorials/tutorialsService";

interface AddHyperlinkTutorialProps {
    container: string;
    fileExtensionSplitter: (filename: string) => [string, string];
    onSubmit: (displayTitle: string, response: string) => void;
}

export const AddTutorialHyperlinkFlyout: FC<AddHyperlinkTutorialProps> = (props: AddHyperlinkTutorialProps): JSX.Element => {
  const [title, setTitle] = useState("");
  const [URL, setURL] = useState("");
  const flyoutContext = useContext(FlyoutContext);
  const supportService = useRef(new TutorialsService()).current;

  const handleSubmit = async () => {

    const newDataStr = await supportService.updateHyperlinkBlobSas(props.container, title, URL);

    props.onSubmit(title, newDataStr);
    flyoutContext.handleCloseFlyout();
  };

    return (
        <>
            <div className="form-group row">
                <div className="col-6">
                    <QESTextInput
                        label="Display Title:"
                        testId="tutorials__file-name-input"
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setTitle(e.target.value)}
                        value={title}
                    />
                </div>
            </div>

            <QESTextArea
              label="Hyperlink:"
              testId="tutorials__file-name-input"
              onChange={(e) => setURL(e.target.value)}
              value={URL}
            />

            <FlyoutFooter
              submitButton={<QESButton qesType="primary" qesTestId="termination-flyout__submit" onClick={handleSubmit} disabled={!title || !URL }>Submit</QESButton>}
            />
        </>
    );
}